import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Mail, ArrowLeft, Loader2 } from 'lucide-react';
import axios from '../../config/axios';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [manualResetUrl, setManualResetUrl] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setManualResetUrl(null);

        try {
            const res = await axios.post('/auth/forgotpassword', { email });

            setSuccess(true);

            if (res.data.manualResetUrl) {
                setManualResetUrl(res.data.manualResetUrl);
                toast.warning('Email gagal dihantar, sila gunakan pautan manual.');
            } else {
                toast.success('Email set semula kata laluan telah dihantar!');
            }
        } catch (error) {
            setSuccess(false);
            const message = error.response?.data?.message || 'Gagal menghantar email';
            toast.error(message);
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
                <div className="bg-slate-800 rounded-2xl p-8 w-full max-w-md border border-slate-700 text-center">
                    <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                        <Mail className="w-8 h-8 text-green-500" />
                    </div>
                    <h2 className="text-2xl font-bold text-white mb-2">
                        {manualResetUrl ? 'Pautan Reset Manual' : 'Semak Email Anda'}
                    </h2>
                    <p className="text-slate-400 mb-8">
                        {manualResetUrl
                            ? 'Sistem email mengalami masalah teknikal. Sila klik butang di bawah untuk reset kata laluan anda:'
                            : <>Kami telah menghantar pautan untuk menetapkan semula kata laluan ke <strong>{email}</strong></>
                        }
                    </p>

                    {manualResetUrl && (
                        <div className="mb-6 p-4 bg-slate-900 rounded-xl break-all">
                            <a
                                href={manualResetUrl}
                                className="text-blue-400 hover:text-blue-300 underline font-medium"
                            >
                                Klik Di Sini Untuk Reset Password
                            </a>
                        </div>
                    )}

                    <div className="space-y-4">
                        <Link to="/login" className="w-full inline-flex justify-center items-center py-3 px-4 rounded-xl bg-slate-700 text-white font-medium hover:bg-slate-600 transition-colors">
                            <ArrowLeft className="w-4 h-4 mr-2" />
                            Kembali ke Log Masuk
                        </Link>
                        <button
                            onClick={() => {
                                setSuccess(false);
                                setEmail('');
                                setManualResetUrl(null);
                            }}
                            className="text-slate-400 hover:text-white text-sm"
                        >
                            {manualResetUrl ? 'Cuba lagi' : 'Tidak menerima email? Cuba lagi'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-4">
            {/* Background Effects */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
                <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl" />
            </div>

            <div className="w-full max-w-md relative z-10">
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-white mb-2">Lupa Kata Laluan?</h1>
                    <p className="text-slate-400">Masukkan email anda untuk kami hantar pautan reset.</p>
                </div>

                <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-slate-700 p-8 shadow-xl">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-2">
                                Email
                            </label>
                            <div className="relative">
                                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full pl-10 pr-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                                    placeholder="nama@email.com"
                                    required
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-medium rounded-xl shadow-lg shadow-blue-500/20 transition-all transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                        >
                            {loading ? (
                                <>
                                    <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                                    Menghantar...
                                </>
                            ) : (
                                'Hantar Pautan Reset'
                            )}
                        </button>
                    </form>

                    <div className="mt-6 text-center">
                        <Link to="/login" className="inline-flex items-center text-sm text-slate-400 hover:text-white transition-colors">
                            <ArrowLeft className="w-4 h-4 mr-2" />
                            Kembali ke Log Masuk
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
